// import React, { useEffect, useState } from "react";
// import { Helmet } from "react-helmet-async";
// //import axios from "axios";
// import "./HomePage.css";
// //import { FaUser, FaEye, FaThumbsUp } from "react-icons/fa";
// import Skeleton from "react-loading-skeleton";
// import "react-loading-skeleton/dist/skeleton.css";
// import { Link } from 'react-router-dom';
// import { slugify } from "../../utils/slugify";
// import { getRequest } from "../../services/api";

// interface BlogPost {
//   _id: string;
//   slug: string;
//   header_title: string;
//   url_title: string;
//   category_name: string;
//   sub_category_name: string;
//   test_category_name: string;
//   image: string;
//   posted_by: string;
//   updated_at: string;
//   views: number;
//   likes: number;
// }

// const HomePage = () => {
//   const [mcqsBlogs, setMcqsBlogs] = useState<BlogPost[]>([]);
//   const [testSeriesBlogs, setTestSeriesMcqsBlogs] = useState<BlogPost[]>([]);
//   const [postsBlogs, setPostsBlogs] = useState<BlogPost[]>([]);
//   const [postsTechnicalBlogs, setPostsTechnicalBlogs] = useState<BlogPost[]>([]);
//   const [postsInterviewQuestionsBlogs, setPostsInterviewQuestionsBlogs] = useState<BlogPost[]>([]);
//   const [mcqsBlogsCount, setMcqsBlogsCount] = useState();
//   const [testSeriesBlogsCount, setTestSeriesMcqsBlogsCount] = useState();
//   const [postsBlogsCount, setPostsBlogsCount] = useState();
//   const [postsTechnicalBlogsCount, setPostsTechnicalBlogsCount] = useState();
//   const [postsInterviewQuestionsBlogsCount, setPostsInterviewQuestionsBlogsCount] = useState();
//   const [loading, setLoading] = useState(true);

//   useEffect(() => {
//     fetchMcqsBlogs();
//     fetchTestSeriesBlogs();
//     fetchPostsBlogs();
//     fetchPostsTechnicalBlogs();
//     fetchPostsInterviewBlogs();
//   }, []);

//   const fetchMcqsBlogs = async () => {
//     try {
//       const response = await getRequest('/blogs', {category: "mcqs", limit: 8})
      
//       setMcqsBlogs(response.data.blogs);
//       setMcqsBlogsCount(response.data.totalCount);
//     } catch (error) {
//       console.error("Error fetching MCQs blogs:", error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const fetchTestSeriesBlogs = async () => {
//     try {
//       // const response = await axios.get("http://acadebility-alb-1319656764.us-east-1.elb.amazonaws.com/api/v1/blogs?category=posts");
//       const response = await getRequest('/blogs', {category: "test_series", limit: 8})
//       //console.log("RESPONSE:", response);
//       setTestSeriesMcqsBlogs(response.data.blogs);
//       setTestSeriesMcqsBlogsCount(response.data.totalCount);
//     } catch (error) {
//       console.error("Error fetching TEST SERIES:", error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const fetchPostsBlogs = async () => {
//     try {
//       // const response = await axios.get("http://acadebility-alb-1319656764.us-east-1.elb.amazonaws.com/api/v1/blogs?category=posts");
//       //const response = await axios.get("http://localhost:5001/api/v1/blogs?category=posts&limit=6");
//       const response = await getRequest('/blogs', {category: "posts", limit: 5})
//       //console.log("RESPONSE BLOG:", response.data.blogs[0]);
//       setPostsBlogs(response.data.blogs);
//       setPostsBlogsCount(response.data.totalCount);
//     } catch (error) {
//       console.error("Error fetching POSTS blogs:", error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const fetchPostsTechnicalBlogs = async () => {
//     try {
//       // const response = await axios.get("http://acadebility-alb-1319656764.us-east-1.elb.amazonaws.com/api/v1/blogs?category=posts");
//       //const response = await axios.get("http://localhost:5001/api/v1/blogs?category=technical_posts&limit=6");
//       const response = await getRequest('/blogs', {category: "technical_posts", limit: 5})
//       //console.log("RESPONSE:", response);
//       setPostsTechnicalBlogs(response.data.blogs);
//       setPostsTechnicalBlogsCount(response.data.totalCount);
//     } catch (error) {
//       console.error("Error fetching POSTS blogs:", error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const fetchPostsInterviewBlogs = async () => {
//     try {
//       // const response = await axios.get("http://acadebility-alb-1319656764.us-east-1.elb.amazonaws.com/api/v1/blogs?category=posts");
//       //const response = await axios.get("http://localhost:5001/api/v1/blogs?category=interview_questions&limit=6");
//       const response = await getRequest('/blogs', {category: "interview_questions", limit: 8})
//       //console.log("RESPONSE:", response);
//       setPostsInterviewQuestionsBlogs(response.data.blogs);
//       setPostsInterviewQuestionsBlogsCount(response.data.totalCount);
//     } catch (error) {
//       console.error("Error fetching POSTS blogs:", error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <>
//       <Helmet>
//         <title>Acadebility - Easy Learn</title>
//         <meta name="description" content="Read Acadebility is an online platform by acadebility" />
//         <meta name="author" content="Acadebility" />
//       </Helmet>
//       {/* Hero Section */}
//       <section className="hero-section">
//         <div className="container">
//           <div className="row align-items-center">

//             {/* ====== Left Column: Text Content ====== */}
//             <div className="col-lg-6 col-md-12">
//               <div className="hero-content">
//                 <span className="leader-badge">
//                   {/* <FaTrophy className="trophy-icon" />  */}
//                   The Leader in Online Learning
//                 </span>
//                 <h1>Build Skills That Shape Your Future.</h1>
//                 <p className="hero-description">
//                   Gain the confidence and knowledge to excel in your career path.
//                 </p>
//                 <Link to={`/online-test-series`} className="view-all-new">
//                   View More Tests ({testSeriesBlogsCount}) &rarr;
//               </Link>
//               </div>
//             </div>

//             {/* ====== Right Column: Image and Course Card ====== */}
//             <div className="col-lg-6 col-md-12 hero-image-column">
//               <div className="hero-image-wrapper">
//                 {/* <img src={studentImage} alt="Student learning online" className="student-image" /> */}
                
//                 {/* --- Floating Course Card --- */}
//                 <div className="course-card">
//                   <div className="course-card-image-wrapper">
//                       {/* <img src={courseThumbnail} alt="Python course thumbnail" className="course-thumbnail" /> */}
//                       <img src={"https://acadebility-images.s3.us-east-1.amazonaws.com/blogs-title/aws-ec2.PNG"} alt="Python course thumbnail" className="course-thumbnail" />
                      
//                       <span className="discount-badge">Free Test</span>
//                   </div>
//                   <div className="course-card-body">
//                       <div className="course-meta">
//                           <span>7 tests</span>
//                           <span>5 free Tests</span>
//                       </div>
//                       <h5 className="course-title text-left">AWS EC2 Online MCQS Test</h5>
//                       <div className="course-rating">
//                           {/* <FaStar /><FaStar /><FaStar /><FaStar /><FaStar className="star-empty" /> */}
//                           <span className="review-count">(15 Reviews)</span>
//                       </div>
//                       <div className="course-footer">
//                           <div className="card-meta-hero">
//                           {/* <span>{blog.views} Lessons</span>
//                           <span>{blog.likes} Students</span> */}
//                           <span>{0} Views</span>
//                           <span>{0} Likes</span>
//                       </div>
//                           <a href="/online-tests/aws-ec2/aws-ec2-online-mcqs-test" className="learn-more-link">View All Tests &rarr;</a>
//                       </div>
//                   </div>
//                 </div>
//               </div>
//             </div>

//           </div>
//         </div>
//       </section>
      
//       {/* ================================================================= */}
//       {/* NEW POPULAR TEST SERIES SECTION STARTS                  */}
//       {/* ================================================================= */}
//       <section className="popular-courses-section">
//         <div className="container-fluid px-lg-5">
//           {/* Section Header */}
//           <div className="section-header text-center">
//             <span className="section-header-badge">TOP POPULAR Test Series</span>
//             <h2>Our Popular Test Series</h2>
//             <Link to={`/online-test-series`} className="view-all-new">
//                   View More ({testSeriesBlogsCount}) &rarr;
//           </Link>
//           </div>

//           {/* Course Cards Grid */}
//           <div className="row">
//             {loading ? (
//               // Show skeletons while loading
//               Array.from({ length: 3 }).map((_, idx) => (
//                 <div className="col-lg-3 col-md-6 mb-4" key={idx}>
//                    <div className="course-card-v2">
//                         <Skeleton height={220} style={{ borderRadius: '15px 15px 0 0' }} />
//                         <div className="card-body">
//                             <Skeleton width="40%" />
//                             <h3 className="card-title"><Skeleton /></h3>
//                             <Skeleton count={2} />
//                         </div>
//                    </div>
//                 </div>
//               ))
//             ) : (
//               // Actual content after loading
//               testSeriesBlogs.map((blog) => (
//                 <div className="col-lg-3 col-md-6 mb-4" key={blog._id}>
//                   <Link to={`/online-tests/${slugify(blog.test_category_name)}/${blog.slug}`} className="text-decoration-none text-dark">
//                   <div className="course-card-v2">
//                     <div className="card-thumbnail-wrapper">
//                       <img src={blog.image} alt={blog.header_title} className="card-thumbnail-img" />
//                       <div className="card-thumbnail-overlay">
//                           <span className="discount-badge-v2">-{20}% OFF</span>
//                       </div>
//                     </div>
//                     <div className="card-body">
//                       <div className="card-top-row">
//                           <div className="card-rating">
//                               {/* <FaStar />
//                               <FaStar />
//                               <FaStar />
//                               <FaStar />
//                               <FaStar className="star-empty" />
//                               <span>({blog.reviews} Reviews)</span> */}
//                           </div>
//                           {/* <FaRegBookmark className="bookmark-icon" /> */}
//                       </div>
//                       <Link to={`/online-tests/${slugify(blog.test_category_name)}/${blog.slug}`} className='text-decoration-none'>
//                         <h3 className="card-title text-left">{blog.header_title}</h3>
//                       </Link>
//                       <div className="card-meta">
//                           {/* <span>{blog.views} Lessons</span>
//                           <span>{blog.likes} Students</span> */}
//                           <span>{blog.views} Views</span>
//                           <span>{blog.likes} Likes</span>
//                       </div>
//                     </div>
//                   </div>
//                   </Link>
//                 </div>
//               ))
//             )}
//           </div>
          
//         </div>
        
//       </section>
//       {/* ================================================================= */}
//       {/* NEW: BLOG POSTS SECTION                                           */}
//       {/* ================================================================= */}
//       <section className="blog-posts-section">
//         <div className="container-fluid px-lg-5"> {/* Added padding for consistency */}
//           {/* Section Header */}
//           <div className="section-header justify-content-start align-items-center mb-5">
//             <span className="section-header-badge">BLOG POST</span>
//             <h2>Latest Blog Post.</h2>
//             <Link to={`/blogs/all-blogs/posts`} className="see-all-articles-btn">
//               See All Blogs ({postsBlogsCount})&rarr;
//             </Link>
//           </div>

//           <div className="row">
//             {/* Left Column: Large Popular Post */}
//             <div className="col-lg-7 mb-4">
//               {loading || !postsBlogs[0] ? (
//                 <div className="large-blog-card skeleton-card">
//                     <Skeleton height={350} style={{ borderRadius: '15px 15px 0 0' }} />
//                     <div className="card-content p-4">
//                         <Skeleton width="60%" />
//                         <h3 className="mb-3"><Skeleton height={30} /></h3>
//                         <Skeleton count={2} />
//                         <div className="learn-more mt-3"><Skeleton width="30%" /></div>
//                     </div>
//                 </div>
//               ) : (
//                 <div className="large-blog-card">
//                   <div className="card-image-wrapper">
//                       <img src={postsBlogs[0].image} alt={postsBlogs[0].header_title} className="card-img" />
//                   </div>
//                   <div className="card-content">
//                       <Link 
//                         to={`/blogs/blog-post/${postsBlogs[0].category_name ? slugify(postsBlogs[0].category_name) : 'category'}/${postsBlogs[0].sub_category_name ? slugify(postsBlogs[0].sub_category_name) : 'subcategory'}/${postsBlogs[0].slug}`} 
//                         state={{ id: postsBlogs[0]._id }} 
//                         className="text-decoration-none text-dark"
//                       >
//                         <h3>{postsBlogs[0].header_title}</h3>
//                       </Link>
//                       {/* <p>{postsBlogs[0].description}</p> */}
//                       <Link 
//                         to={`/blogs/blog-post/${postsBlogs[0].category_name ? slugify(postsBlogs[0].category_name) : 'category'}/${postsBlogs[0].sub_category_name ? slugify(postsBlogs[0].sub_category_name) : 'subcategory'}/${postsBlogs[0].slug}`} 
//                         state={{ id: postsBlogs[0]._id }} 
//                         className="learn-more-link"
//                       >
//                           Learn More &rarr;
//                       </Link>
//                   </div>
//                 </div>
//               )}
//             </div>

//             {/* Right Column: Smaller Blog Post List */}
//             <div className="col-lg-5">
//               {loading ? (
//                 Array.from({ length: 3 }).map((_, idx) => (
//                   <div className="small-blog-card skeleton-card mb-4" key={idx}>
//                       <Skeleton height={100} width={150} style={{ marginRight: '15px' }} />
//                       <div className="card-text-content">
//                           <Skeleton width="80%" />
//                           <Skeleton width="50%" />
//                       </div>
//                   </div>
//                 ))
//               ) : (
//                 postsBlogs.map((blog) => (
//                   <div className="small-blog-card mb-4" key={blog._id}>
//                     <img src={blog.image} alt={blog.header_title} className="small-card-img" />
//                     <div className="card-text-content">
//                         <Link 
//                           to={`/blogs/blog-post/${blog.category_name ? slugify(blog.category_name) : 'category'}/${blog.sub_category_name ? slugify(blog.sub_category_name) : 'subcategory'}/${blog.slug}`} 
//                           state={{ id: blog._id }} 
//                           className="text-decoration-none text-dark"
//                         >
//                           <h4>{blog.header_title}</h4>
//                         </Link>
//                         <Link 
//                           to={`/blogs/blog-post/${blog.category_name ? slugify(blog.category_name) : 'category'}/${blog.sub_category_name ? slugify(blog.sub_category_name) : 'subcategory'}/${blog.slug}`} 
//                           state={{ id: blog._id }} 
//                           className="read-article-link"
//                         >
//                             Read Article &rarr;
//                         </Link>
//                     </div>
//                   </div>
//                 ))
//               )}
//             </div>
//           </div>
//         </div>
//       </section>
//       {/* ================================================================= */}
//       {/* NEW POPULAR MCQS SECTION STARTS                  */}
//       {/* ================================================================= */}
//       <section className="popular-courses-section">
//         <div className="container-fluid px-lg-5">
//           {/* Section Header */}
//           <div className="section-header text-center">
//             <span className="section-header-badge">TOP POPULAR MCQ's</span>
//             <h2>Our Popular MCQ's</h2>
//             <Link to={`/blogs/all-blogs/mcqs`} className="view-all-new">
//                   View More ({mcqsBlogsCount}) &rarr;
//           </Link>
//           </div>

//           {/* Course Cards Grid */}
//           <div className="row">
//             {loading ? (
//               // Show skeletons while loading
//               Array.from({ length: 3 }).map((_, idx) => (
//                 <div className="col-lg-3 col-md-6 mb-4" key={idx}>
//                    <div className="course-card-v2">
//                         <Skeleton height={220} style={{ borderRadius: '15px 15px 0 0' }} />
//                         <div className="card-body">
//                             <Skeleton width="40%" />
//                             <h3 className="card-title"><Skeleton /></h3>
//                             <Skeleton count={2} />
//                         </div>
//                    </div>
//                 </div>
//               ))
//             ) : (
//               // Actual content after loading
//               mcqsBlogs.map((blog) => (
//                 <div className="col-lg-3 col-md-6 mb-4" key={blog._id}>
//                   <Link to={`/mcqs/mcqs-post/${slugify(blog.category_name)}/${slugify(blog.sub_category_name.replace(/\0/g, "").trim())}/${blog.slug}`} className="text-decoration-none text-dark">
//                   <div className="course-card-v2">
//                     <div className="card-thumbnail-wrapper">
//                       <img src={blog.image} alt={blog.header_title} className="card-thumbnail-img" />
//                       <div className="card-thumbnail-overlay">
//                           <span className="discount-badge-v2">-{20}% OFF</span>
//                       </div>
//                     </div>
//                     <div className="card-body">
//                       <div className="card-top-row">
//                           <div className="card-rating">
//                               {/* <FaStar />
//                               <FaStar />
//                               <FaStar />
//                               <FaStar />
//                               <FaStar className="star-empty" />
//                               <span>({blog.reviews} Reviews)</span> */}
//                           </div>
//                           {/* <FaRegBookmark className="bookmark-icon" /> */}
//                       </div>
//                       <Link to={`/mcqs/mcqs-post/${slugify(blog.category_name)}/${slugify(blog.sub_category_name.replace(/\0/g, "").trim())}/${blog.slug}`} className='text-decoration-none'>
//                         <h3 className="card-title text-left">{blog.header_title}</h3>
//                       </Link>
//                       <div className="card-meta">
//                           {/* <span>{blog.views} Lessons</span>
//                           <span>{blog.likes} Students</span> */}
//                           <span>{blog.views} Views</span>
//                           <span>{blog.likes} Likes</span>
//                       </div>
//                     </div>
//                   </div>
//                   </Link>
//                 </div>
//               ))
//             )}
//           </div>
//         </div>
//       </section>
//       {/* ================================================================= */}
//       {/* NEW: TECHNICAL BLOG POSTS SECTION                                           */}
//       {/* ================================================================= */}
//       <section className="blog-posts-section">
//         <div className="container-fluid px-lg-5"> {/* Added padding for consistency */}
//           {/* Section Header */}
//           <div className="section-header justify-content-start align-items-center mb-5">
//             <span className="section-header-badge">Technical BLOG POST</span>
//             <h2>Latest Technical Blog Post.</h2>
//             <Link to={`/blogs/all-blogs/technical_posts`} className="see-all-articles-btn">
//               See All Technical Blogs ({postsTechnicalBlogsCount})&rarr;
//             </Link>
//           </div>

//           <div className="row">
//             {/* Left Column: Large Popular Post */}
//             <div className="col-lg-7 mb-4">
//               {loading || !postsTechnicalBlogs[0] ? (
//                 <div className="large-blog-card skeleton-card">
//                     <Skeleton height={350} style={{ borderRadius: '15px 15px 0 0' }} />
//                     <div className="card-content p-4">
//                         <Skeleton width="60%" />
//                         <h3 className="mb-3"><Skeleton height={30} /></h3>
//                         <Skeleton count={2} />
//                         <div className="learn-more mt-3"><Skeleton width="30%" /></div>
//                     </div>
//                 </div>
//               ) : (
//                 <div className="large-blog-card">
//                   <div className="card-image-wrapper">
//                       <img src={postsTechnicalBlogs[0].image} alt={postsTechnicalBlogs[0].header_title} className="card-img" />
//                   </div>
//                   <div className="card-content">
//                       <Link 
//                         to={`/blogs/blog-post/${postsTechnicalBlogs[0].category_name ? slugify(postsTechnicalBlogs[0].category_name) : 'category'}/${postsTechnicalBlogs[0].sub_category_name ? slugify(postsTechnicalBlogs[0].sub_category_name) : 'subcategory'}/${postsTechnicalBlogs[0].slug}`} 
//                         state={{ id: postsTechnicalBlogs[0]._id }} 
//                         className="text-decoration-none text-dark"
//                       >
//                         <h3>{postsTechnicalBlogs[0].header_title}</h3>
//                       </Link>
//                       {/* <p>{postsTechnicalBlogs[0].description}</p> */}
//                       <Link 
//                         to={`/blogs/blog-post/${postsTechnicalBlogs[0].category_name ? slugify(postsTechnicalBlogs[0].category_name) : 'category'}/${postsTechnicalBlogs[0].sub_category_name ? slugify(postsTechnicalBlogs[0].sub_category_name) : 'subcategory'}/${postsTechnicalBlogs[0].slug}`} 
//                         state={{ id: postsTechnicalBlogs[0]._id }} 
//                         className="learn-more-link"
//                       >
//                           Learn More &rarr;
//                       </Link>
//                   </div>
//                 </div>
//               )}
//             </div>

//             {/* Right Column: Smaller Blog Post List */}
//             <div className="col-lg-5">
//               {loading ? (
//                 Array.from({ length: 3 }).map((_, idx) => (
//                   <div className="small-blog-card skeleton-card mb-4" key={idx}>
//                       <Skeleton height={100} width={150} style={{ marginRight: '15px' }} />
//                       <div className="card-text-content">
//                           <Skeleton width="80%" />
//                           <Skeleton width="50%" />
//                       </div>
//                   </div>
//                 ))
//               ) : (
//                 postsTechnicalBlogs.map((blog) => (
//                   <div className="small-blog-card mb-4" key={blog._id}>
//                     <img src={blog.image} alt={blog.header_title} className="small-card-img" />
//                     <div className="card-text-content">
//                         <Link 
//                           to={`/blogs/blog-post/${blog.category_name ? slugify(blog.category_name) : 'category'}/${blog.sub_category_name ? slugify(blog.sub_category_name) : 'subcategory'}/${blog.slug}`} 
//                           state={{ id: blog._id }} 
//                           className="text-decoration-none text-dark"
//                         >
//                           <h4>{blog.header_title}</h4>
//                         </Link>
//                         <Link 
//                           to={`/blogs/blog-post/${blog.category_name ? slugify(blog.category_name) : 'category'}/${blog.sub_category_name ? slugify(blog.sub_category_name) : 'subcategory'}/${blog.slug}`} 
//                           state={{ id: blog._id }} 
//                           className="read-article-link"
//                         >
//                             Read Article &rarr;
//                         </Link>
//                     </div>
//                   </div>
//                 ))
//               )}
//             </div>
//           </div>
//         </div>
//       </section>
//       {/* ================================================================= */}
//       {/* NEW INTERVIEW QUESTIONS SECTION STARTS                  */}
//       {/* ================================================================= */}
//       <section className="popular-courses-section">
//         <div className="container-fluid px-lg-5">
//           {/* Section Header */}
//           <div className="section-header text-center">
//             <span className="section-header-badge">TOP POPULAR INTERVIEW QUESTIONS</span>
//             <h2>Our Popular Interview Questions</h2>
//             <Link to={`/blogs/all-blogs/interview_questions`} className="view-all-new">
//                   View More ({postsInterviewQuestionsBlogsCount}) &rarr;
//           </Link>
//           </div>

//           {/* Course Cards Grid */}
//           <div className="row">
//             {loading ? (
//               // Show skeletons while loading
//               Array.from({ length: 3 }).map((_, idx) => (
//                 <div className="col-lg-3 col-md-6 mb-4" key={idx}>
//                    <div className="course-card-v2">
//                         <Skeleton height={220} style={{ borderRadius: '15px 15px 0 0' }} />
//                         <div className="card-body">
//                             <Skeleton width="40%" />
//                             <h3 className="card-title"><Skeleton /></h3>
//                             <Skeleton count={2} />
//                         </div>
//                    </div>
//                 </div>
//               ))
//             ) : (
//               // Actual content after loading
//               postsInterviewQuestionsBlogs.map((blog) => (
//                 <div className="col-lg-3 col-md-6 mb-4" key={blog._id}>
//                   <Link to={`/blogs/blog-post/${slugify(blog.category_name)}/${slugify(blog.sub_category_name.replace(/\0/g, "").trim())}/${blog.slug}`} className="text-decoration-none text-dark">
//                   <div className="course-card-v2">
//                     <div className="card-thumbnail-wrapper">
//                       <img src={blog.image} alt={blog.header_title} className="card-thumbnail-img" />
//                       <div className="card-thumbnail-overlay">
//                           <span className="discount-badge-v2">-{20}% OFF</span>
//                       </div>
//                     </div>
//                     <div className="card-body">
//                       <div className="card-top-row">
//                           <div className="card-rating">
//                               {/* <FaStar />
//                               <FaStar />
//                               <FaStar />
//                               <FaStar />
//                               <FaStar className="star-empty" />
//                               <span>({blog.reviews} Reviews)</span> */}
//                           </div>
//                           {/* <FaRegBookmark className="bookmark-icon" /> */}
//                       </div>
//                       <Link to={`/blogs/blog-post/${slugify(blog.category_name)}/${slugify(blog.sub_category_name.replace(/\0/g, "").trim())}/${blog.slug}`} className='text-decoration-none'>
//                         <h3 className="card-title text-left">{blog.header_title}</h3>
//                       </Link>
//                       <div className="card-meta">
//                           {/* <span>{blog.views} Lessons</span>
//                           <span>{blog.likes} Students</span> */}
//                           <span>{blog.views} Views</span>
//                           <span>{blog.likes} Likes</span>
//                       </div>
//                     </div>
//                   </div>
//                   </Link>
//                 </div>
//               ))
//             )}
//           </div>
//         </div>
//       </section>
//         {/* <div className="section-header">
//           <h2>Recent MCQs ({mcqsBlogsCount})</h2>
//           <Link to={`/blogs/all-blogs/mcqs`} className="view-all-btns">View All</Link>
//         </div> */}
//         {/* <div className="row">
//           {loading ? (
//             // Show skeletons while loading
//             Array.from({ length: 6 }).map((_, idx) => (
//               <div className="col-lg-2 col-sm-6 portfolio-item" key={idx}>
//                 <div className="card h-100 blog-card">
//                   <Skeleton height={120} />
//                   <div className="card-body">
//                     <h5><Skeleton width={100} /></h5>
//                     <p className="meta-info"><Skeleton width={60} /></p>
//                     <div className="stats">
//                       <Skeleton width={40} /> <Skeleton width={40} />
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             ))
//           ) : (
//             // Actual content after loading
//             mcqsBlogs.map((blog) => (
//               <div className="col-lg-2 col-md-3 col-sm-6 portfolio-item" key={blog._id}>
//                 <Link to={`/mcqs/mcqs-post/${slugify(blog.category_name)}/${slugify(blog.sub_category_name.replace(/\0/g, "").trim())}/${blog.slug}`} state={{ id: blog._id }} className="text-decoration-none text-dark">
//                 <div className="card h-100 blog-card" style={{ borderRadius: "1rem" }}>
//                   <img className="card-img-top" src={blog.image} alt={blog.header_title} />
//                   <div className="card-body text-left">
//                     <h5 className="card-title">{blog.header_title}</h5>
//                     <p className="meta-info">{blog.posted_by}</p>
//                     <div className="stats">
//                       <span>👁 {blog.views}</span> &nbsp;
//                       <span>👍 {blog.likes}</span>
//                     </div>
//                   </div>
//                 </div>
//                 </Link>
//               </div>
//             ))
//           )}
//         </div> */}

//         {/* <div className="section-header">
//           <h2>Latest Test Series ({testSeriesBlogsCount})</h2>
//           <Link to={`/blogs/all-blogs/test_series`} className="view-all-btns">View All</Link>
//         </div>

//         <div className="row">
//           {loading ? (
//             // Show skeletons while loading
//             Array.from({ length: 6 }).map((_, idx) => (
//               <div className="col-lg-2 col-sm-6 portfolio-item" key={idx}>
//                 <div className="card h-100 blog-card">
//                   <Skeleton height={120} />
//                   <div className="card-body">
//                     <h5><Skeleton width={100} /></h5>
//                     <p className="meta-info"><Skeleton width={60} /></p>
//                     <div className="stats">
//                       <Skeleton width={40} /> <Skeleton width={40} />
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             ))
//           ) : (
//             // Actual content after loading
//             testSeriesBlogs.map((blog) => (
//               <div className="col-lg-2 col-sm-6 portfolio-item" key={blog._id}>
//                 <Link to={`/online-tests/${slugify(blog.test_category_name)}/${blog.slug}`} className="text-decoration-none text-dark">
//                 <div className="card h-100 blog-card" style={{ borderRadius: "1rem" }}>
//                   <img className="card-img-top" src={blog.image} alt={blog.header_title} />
//                   <div className="card-body text-left">
//                     <h5 className="card-title">{blog.header_title}</h5>
//                     <p className="meta-info">{blog.posted_by}</p>
//                     <div className="stats">
//                       <span>👁 {blog.views}</span> &nbsp;
//                       <span>👍 {blog.likes}</span>
//                     </div>
//                   </div>
//                 </div>
//                 </Link>
//               </div>
//             ))
//           )}
//         </div> */}

//         {/* <div className="section-header">
//           <h2>Recent Blogs POSTS ({postsBlogsCount})</h2>
//           <Link to={`/blogs/all-blogs/posts`} className="view-all-btns">View All</Link>
//         </div>

//         <div className="row">
//           {loading ? (
//             // Show skeletons while loading
//             Array.from({ length: 6 }).map((_, idx) => (
//               <div className="col-lg-2 col-sm-6 portfolio-item" key={idx}>
//                 <div className="card h-100 blog-card">
//                   <Skeleton height={120} />
//                   <div className="card-body">
//                     <h5><Skeleton width={100} /></h5>
//                     <p className="meta-info"><Skeleton width={60} /></p>
//                     <div className="stats">
//                       <Skeleton width={40} /> <Skeleton width={40} />
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             ))
//           ) : (
//             // Actual content after loading
//             postsBlogs.map((blog) => (
//               <div className="col-lg-2 col-sm-6 portfolio-item" key={blog._id}>
//                 <Link to={`/blogs/blog-post/${slugify(blog.category_name)}/${slugify(blog.sub_category_name)}/${blog.slug}`} state={{ id: blog._id }} className="text-decoration-none text-dark">
//                 <div className="card h-100 blog-card">
//                   <img className="card-img-top" src={blog.image} alt={blog.header_title} />
//                   <div className="card-body text-left">
//                     <h5 className="card-title">{blog.header_title}</h5>
//                     <p className="meta-info">{blog.posted_by}</p>
//                     <div className="stats">
//                       <span>👁 {blog.views}</span> &nbsp;
//                       <span>👍 {blog.likes}</span>
//                     </div>
//                   </div>
//                 </div>
//                 </Link>
//               </div>
//             ))
//           )}
//         </div> */}
//         <div className="container-fluid homepage">
//         {/* //technical_posts starts header */}
//         {/* <div className="section-header">
//           <h2>Recent Technical Blogs POSTS ({postsTechnicalBlogsCount})</h2>
//           <Link to={`/blogs/all-blogs/technical_posts`} className="view-all-btns">View All</Link>
//         </div>
//         <div className="row">
//           {loading ? (
//             // Show skeletons while loading
//             Array.from({ length: 6 }).map((_, idx) => (
//               <div className="col-lg-2 col-sm-6 portfolio-item" key={idx}>
//                 <div className="card h-100 blog-card">
//                   <Skeleton height={120} />
//                   <div className="card-body">
//                     <h5><Skeleton width={100} /></h5>
//                     <p className="meta-info"><Skeleton width={60} /></p>
//                     <div className="stats">
//                       <Skeleton width={40} /> <Skeleton width={40} />
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             ))
//           ) : (
//             // Actual content after loading
//             postsTechnicalBlogs.map((blog) => (
//               <div className="col-lg-2 col-sm-6 portfolio-item" key={blog._id}>
//                 <Link to={`/blogs/blog-post/${slugify(blog.category_name)}/${slugify(blog.sub_category_name)}/${blog.slug}`} state={{ id: blog._id }} className="text-decoration-none text-dark">
//                 <div className="card h-100 blog-card">
//                   <img className="card-img-top" src={blog.image} alt={blog.header_title} />
//                   <div className="card-body text-left">
//                     <h5 className="card-title">{blog.header_title}</h5>
//                     <p className="meta-info">{blog.posted_by}</p>
//                     <div className="stats">
//                       <span>👁 {blog.views}</span> &nbsp;
//                       <span>👍 {blog.likes}</span>
//                     </div>
//                   </div>
//                 </div>
//                 </Link>
//               </div>
//             ))
//           )}
//         </div> */}
//         {/* //Interview Questions starts header */}
//         {/* <div className="section-header">
//           <h2>Recent Interview Questions Blogs ({postsInterviewQuestionsBlogsCount})</h2>
//           <Link to={`/blogs/all-blogs/interview_questions`} className="view-all-btns">View All</Link>
//         </div>
//         <div className="row">
//           {loading ? (
//             // Show skeletons while loading
//             Array.from({ length: 6 }).map((_, idx) => (
//               <div className="col-lg-2 col-sm-6 portfolio-item" key={idx}>
//                 <div className="card h-100 blog-card">
//                   <Skeleton height={120} />
//                   <div className="card-body">
//                     <h5><Skeleton width={100} /></h5>
//                     <p className="meta-info"><Skeleton width={60} /></p>
//                     <div className="stats">
//                       <Skeleton width={40} /> <Skeleton width={40} />
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             ))
//           ) : (
//             // Actual content after loading
//             postsInterviewQuestionsBlogs.map((blog) => (
//               <div className="col-lg-2 col-sm-6 portfolio-item" key={blog._id}>
//                 <Link to={`/blogs/blog-post/${slugify(blog.category_name)}/${slugify(blog.sub_category_name)}/${blog.slug}`} state={{ id: blog._id }} className="text-decoration-none text-dark">
//                 <div className="card h-100 blog-card">
//                   <img className="card-img-top" src={blog.image} alt={blog.header_title} />
//                   <div className="card-body text-left">
//                     <h5 className="card-title">{blog.header_title}</h5>
//                     <p className="meta-info">{blog.posted_by}</p>
//                     <div className="stats">
//                       <span>👁 {blog.views}</span> &nbsp;
//                       <span>👍 {blog.likes}</span>
//                     </div>
//                   </div>
//                 </div>
//                 </Link>
//               </div>
//             ))
//           )}
//         </div> */}

//       </div>
//     </>
//   );
// };

// export default HomePage;
// import React, { useEffect, useState } from "react";
// import { Helmet } from "react-helmet-async";
// import Skeleton from "react-loading-skeleton";
// import "react-loading-skeleton/dist/skeleton.css";
// import { Link } from "react-router-dom";
// import { slugify } from "../../utils/slugify";
// import { getRequest } from "../../services/api";
// import "./HomePage.css";

// interface BlogPost {
//   _id: string;
//   slug: string;
//   header_title: string;
//   url_title: string;
//   category_name: string;
//   sub_category_name: string;
//   test_category_name: string;
//   image: string;
//   posted_by: string;
//   updated_at: string;
//   views: number;
//   likes: number;
// }

// const IconEye = () => (
//   <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/></svg>
// );
// const IconHeart = () => (
//   <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg>
// );

// interface SectionHeaderProps {
//   badge: string; title: string; linkTo: string; linkLabel: string; count?: number;
// }
// const SectionHeader: React.FC<SectionHeaderProps> = ({ badge, title, linkTo, linkLabel, count }) => (
//   <div className="hp-section-header">
//     <div className="hp-section-header-left">
//       <span className="hp-badge">{badge}</span>
//       <h2 className="hp-section-title">{title}</h2>
//     </div>
//     <Link to={linkTo} className="hp-view-all-btn">
//       {linkLabel}{count ? ` (${count})` : ""} →
//     </Link>
//   </div>
// );

// interface ContentCardProps { blog: BlogPost; linkTo: string; }
// const ContentCard: React.FC<ContentCardProps> = ({ blog, linkTo }) => (
//   <Link to={linkTo} className="hp-content-card-link">
//     <div className="hp-content-card">
//       <div className="hp-card-thumb-wrap">
//         <img src={blog.image} alt={blog.header_title} className="hp-card-thumb" loading="lazy" />
//         <span className="hp-card-badge">-20% OFF</span>
//       </div>
//       <div className="hp-card-body">
//         <h3 className="hp-card-title">{blog.header_title}</h3>
//         <div className="hp-card-meta">
//           <span><IconEye />{blog.views} Views</span>
//           <span><IconHeart />{blog.likes} Likes</span>
//         </div>
//       </div>
//     </div>
//   </Link>
// );

// const CardSkeleton = () => (
//   <div className="hp-content-card">
//     <Skeleton height={200} style={{ borderRadius: "12px 12px 0 0" }} />
//     <div className="hp-card-body">
//       <Skeleton height={18} style={{ marginBottom: 8 }} />
//       <Skeleton width="60%" height={14} />
//     </div>
//   </div>
// );

// interface BlogListItemProps { blog: BlogPost; linkTo: string; }
// const BlogListItem: React.FC<BlogListItemProps> = ({ blog, linkTo }) => (
//   <Link to={linkTo} className="hp-blog-list-item">
//     <img src={blog.image} alt={blog.header_title} className="hp-blog-list-thumb" loading="lazy" />
//     <div className="hp-blog-list-text">
//       <h4 className="hp-blog-list-title">{blog.header_title}</h4>
//       <span className="hp-blog-list-link">Read Article →</span>
//     </div>
//   </Link>
// );

// /* ─── Hero right panel feature items ───────────────────────────────────────── */
// const FEATURES = [
//   { icon: "✅", title: "Topic-wise MCQ Practice",    desc: "Thousands of questions across all subjects & classes" },
//   { icon: "📋", title: "Full-length Mock Tests",       desc: "Simulate real exam conditions with timed tests" },
//   { icon: "📊", title: "Instant Score & Analysis",     desc: "Know exactly where you stand after every attempt" },
//   { icon: "📰", title: "Expert Blog Posts",            desc: "Curated articles, technical guides & interview prep" },
//   { icon: "🆓", title: "Free Tests to Get Started",   desc: "Try before you buy — no account needed" },
// ];

// /* ═══════════════════════════════════════════════════════════════════════════
//    MAIN COMPONENT
// ═══════════════════════════════════════════════════════════════════════════ */
// const HomePage: React.FC = () => {
//   const [mcqsBlogs,           setMcqsBlogs]           = useState<BlogPost[]>([]);
//   const [testSeriesBlogs,     setTestSeriesBlogs]     = useState<BlogPost[]>([]);
//   const [postsBlogs,          setPostsBlogs]          = useState<BlogPost[]>([]);
//   const [postsTechnicalBlogs, setPostsTechnicalBlogs] = useState<BlogPost[]>([]);
//   const [postsInterviewBlogs, setPostsInterviewBlogs] = useState<BlogPost[]>([]);
//   const [mcqsCount,           setMcqsCount]           = useState<number>(0);
//   const [testSeriesCount,     setTestSeriesCount]     = useState<number>(0);
//   const [postsCount,          setPostsCount]          = useState<number>(0);
//   const [technicalCount,      setTechnicalCount]      = useState<number>(0);
//   const [interviewCount,      setInterviewCount]      = useState<number>(0);
//   const [loading,             setLoading]             = useState<boolean>(true);

//   useEffect(() => {
//     const fetchAll = async () => {
//       try {
//         const [mcqRes, tsRes, postRes, techRes, ivRes] = await Promise.all([
//           getRequest("/blogs", { category: "mcqs",                limit: 8 }),
//           getRequest("/blogs", { category: "test_series",         limit: 8 }),
//           getRequest("/blogs", { category: "posts",               limit: 5 }),
//           getRequest("/blogs", { category: "technical_posts",     limit: 5 }),
//           getRequest("/blogs", { category: "interview_questions", limit: 8 }),
//         ]);
//         setMcqsBlogs(mcqRes.data.blogs);            setMcqsCount(mcqRes.data.totalCount);
//         setTestSeriesBlogs(tsRes.data.blogs);        setTestSeriesCount(tsRes.data.totalCount);
//         setPostsBlogs(postRes.data.blogs);           setPostsCount(postRes.data.totalCount);
//         setPostsTechnicalBlogs(techRes.data.blogs);  setTechnicalCount(techRes.data.totalCount);
//         setPostsInterviewBlogs(ivRes.data.blogs);    setInterviewCount(ivRes.data.totalCount);
//       } catch (err) {
//         console.error("HomePage fetch error:", err);
//       } finally {
//         setLoading(false);
//       }
//     };
//     fetchAll();
//   }, []);

//   const blogLink = (b: BlogPost) =>
//     `/blogs/blog-post/${b.category_name ? slugify(b.category_name) : "category"}/${b.sub_category_name ? slugify(b.sub_category_name) : "subcategory"}/${b.slug}`;

//   return (
//     <>
//       <Helmet>
//         <title>Acadebility — Easy Learning</title>
//         <meta name="description" content="Practice MCQs, Test Series, Blog Posts and Interview Questions on Acadebility" />
//       </Helmet>

//       <div className="hp-page">

//         {/* ══════════════════════════════════════════
//             HERO
//         ══════════════════════════════════════════ */}
//         <section className="hp-hero">
//           <div className="hp-hero-inner">

//             {/* ── LEFT: headline & stats ── */}
//             <div className="hp-hero-text">
//               <span className="hp-hero-badge">🏆 The Leader in Online Learning</span>

//               <h1 className="hp-hero-heading">
//                 Build Skills That<br />
//                 <span className="hp-hero-accent">Shape Your Future</span>
//               </h1>

//               <p className="hp-hero-sub">
//                 Practice with thousands of questions across JEE, NEET, UPSC,
//                 Banking, SSC, and more. Track your progress and achieve your goals.
//               </p>

//               <div className="hp-hero-actions">
//                 <Link to="/online-test-series" className="hp-hero-btn-primary">Explore Test Series →</Link>
//                 <Link to="/blogs/all-blogs/mcqs" className="hp-hero-btn-ghost">Browse MCQs</Link>
//               </div>

//               {/* Stats row */}
//               <div className="hp-hero-stats-row">
//                 {[
//                   { val: "500+", lbl: "Test Series" },
//                   { val: "10K+", lbl: "MCQ Questions" },
//                   { val: "1L+",  lbl: "Students" },
//                   { val: "4.8★", lbl: "Avg Rating" },
//                 ].map(s => (
//                   <div className="hp-hero-stat" key={s.lbl}>
//                     <span className="hp-hero-stat-val">{s.val}</span>
//                     <span className="hp-hero-stat-lbl">{s.lbl}</span>
//                   </div>
//                 ))}
//               </div>
//             </div>

//             {/* ── RIGHT: what you get panel ── */}
//             <div className="hp-hero-panel">

//               {/* Top 2 stat chips */}
//               <div className="hp-panel-chips">
//                 <div className="hp-panel-chip hp-panel-chip-teal">
//                   <span className="hp-panel-chip-icon">🎯</span>
//                   <div>
//                     <div className="hp-panel-chip-val">500+</div>
//                     <div className="hp-panel-chip-lbl">Test Series</div>
//                   </div>
//                 </div>
//                 <div className="hp-panel-chip hp-panel-chip-purple">
//                   <span className="hp-panel-chip-icon">👥</span>
//                   <div>
//                     <div className="hp-panel-chip-val">1L+</div>
//                     <div className="hp-panel-chip-lbl">Students</div>
//                   </div>
//                 </div>
//               </div>

//               {/* Feature list */}
//               <div className="hp-panel-card">
//                 <p className="hp-panel-card-heading">What you get on Acadebility</p>
//                 <div className="hp-panel-features">
//                   {FEATURES.map(f => (
//                     <div className="hp-panel-feature" key={f.title}>
//                       <span className="hp-panel-feature-icon">{f.icon}</span>
//                       <div>
//                         <div className="hp-panel-feature-title">{f.title}</div>
//                         <div className="hp-panel-feature-desc">{f.desc}</div>
//                       </div>
//                     </div>
//                   ))}
//                 </div>
//               </div>

//               {/* Bottom mini CTA */}
//               <div className="hp-panel-cta">
//                 <span className="hp-panel-cta-emoji">🚀</span>
//                 <div className="hp-panel-cta-text">
//                   <strong>Start for free today</strong>
//                   <span>No credit card required</span>
//                 </div>
//                 <Link to="/register" className="hp-panel-cta-btn">Join Now →</Link>
//               </div>

//             </div>
//           </div>
//         </section>

//         {/* ══════════════════════════════════════════
//             CATEGORY CHIPS
//         ══════════════════════════════════════════ */}
//         <section className="hp-categories">
//           <div className="hp-section-inner">
//             {[
//               { emoji: "🎯", label: "Test Series",         to: "/online-test-series" },
//               { emoji: "❓", label: "MCQ Practice",        to: "/blogs/all-blogs/mcqs" },
//               { emoji: "📰", label: "Blog Posts",          to: "/blogs/all-blogs/posts" },
//               { emoji: "💻", label: "Technical Blogs",     to: "/blogs/all-blogs/technical_posts" },
//               { emoji: "🤝", label: "Interview Questions", to: "/blogs/all-blogs/interview_questions" },
//             ].map(c => (
//               <Link to={c.to} className="hp-cat-chip" key={c.label}>
//                 <span className="hp-cat-emoji">{c.emoji}</span>
//                 {c.label}
//               </Link>
//             ))}
//           </div>
//         </section>

//         {/* ══════════════════════════════════════════
//             TEST SERIES
//         ══════════════════════════════════════════ */}
//         <section className="hp-section">
//           <div className="hp-section-inner">
//             <SectionHeader badge="🎯 TOP TEST SERIES" title="Our Popular Test Series"
//               linkTo="/online-test-series" linkLabel="View More" count={testSeriesCount} />
//             <div className="hp-cards-grid">
//               {loading ? Array.from({ length: 8 }).map((_, i) => <CardSkeleton key={i} />)
//                 : testSeriesBlogs.map(b => (
//                     <ContentCard key={b._id} blog={b}
//                       linkTo={`/online-tests/${slugify(b.test_category_name)}/${b.slug}`} />
//                   ))}
//             </div>
//           </div>
//         </section>

//         {/* ══════════════════════════════════════════
//             BLOG POSTS
//         ══════════════════════════════════════════ */}
//         <section className="hp-section hp-section-alt">
//           <div className="hp-section-inner">
//             <SectionHeader badge="📰 BLOG POST" title="Latest Blog Posts"
//               linkTo="/blogs/all-blogs/posts" linkLabel="See All Blogs" count={postsCount} />
//             <div className="hp-blog-layout">
//               <div className="hp-blog-main">
//                 {loading || !postsBlogs[0] ? (
//                   <><Skeleton height={320} style={{ borderRadius: 14 }} /><Skeleton height={22} style={{ marginTop: 14 }} /></>
//                 ) : (
//                   <Link to={blogLink(postsBlogs[0])} state={{ id: postsBlogs[0]._id }} className="hp-blog-main-link">
//                     <div className="hp-blog-main-card">
//                       <img src={postsBlogs[0].image} alt={postsBlogs[0].header_title} className="hp-blog-main-img" loading="lazy" />
//                       <div className="hp-blog-main-body">
//                         <h3 className="hp-blog-main-title">{postsBlogs[0].header_title}</h3>
//                         <span className="hp-blog-learn-more">Learn More →</span>
//                       </div>
//                     </div>
//                   </Link>
//                 )}
//               </div>
//               <div className="hp-blog-list">
//                 {loading ? Array.from({ length: 4 }).map((_, i) => (
//                   <div className="hp-blog-list-item" key={i}>
//                     <Skeleton width={80} height={62} style={{ borderRadius: 8, flexShrink: 0 }} />
//                     <div style={{ flex: 1 }}><Skeleton height={15} /><Skeleton width="50%" height={12} /></div>
//                   </div>
//                 )) : postsBlogs.map(b => <BlogListItem key={b._id} blog={b} linkTo={blogLink(b)} />)}
//               </div>
//             </div>
//           </div>
//         </section>

//         {/* ══════════════════════════════════════════
//             MCQ
//         ══════════════════════════════════════════ */}
//         <section className="hp-section">
//           <div className="hp-section-inner">
//             <SectionHeader badge="❓ TOP MCQs" title="Our Popular MCQs"
//               linkTo="/blogs/all-blogs/mcqs" linkLabel="View More" count={mcqsCount} />
//             <div className="hp-cards-grid">
//               {loading ? Array.from({ length: 8 }).map((_, i) => <CardSkeleton key={i} />)
//                 : mcqsBlogs.map(b => (
//                     <ContentCard key={b._id} blog={b}
//                       linkTo={`/mcqs/mcqs-post/${slugify(b.category_name)}/${slugify(b.sub_category_name.replace(/\0/g, "").trim())}/${b.slug}`} />
//                   ))}
//             </div>
//           </div>
//         </section>

//         {/* ══════════════════════════════════════════
//             TECHNICAL BLOGS
//         ══════════════════════════════════════════ */}
//         <section className="hp-section hp-section-alt">
//           <div className="hp-section-inner">
//             <SectionHeader badge="💻 TECHNICAL" title="Latest Technical Blog Posts"
//               linkTo="/blogs/all-blogs/technical_posts" linkLabel="See All Technical Blogs" count={technicalCount} />
//             <div className="hp-blog-layout">
//               <div className="hp-blog-main">
//                 {loading || !postsTechnicalBlogs[0] ? (
//                   <><Skeleton height={320} style={{ borderRadius: 14 }} /><Skeleton height={22} style={{ marginTop: 14 }} /></>
//                 ) : (
//                   <Link to={blogLink(postsTechnicalBlogs[0])} state={{ id: postsTechnicalBlogs[0]._id }} className="hp-blog-main-link">
//                     <div className="hp-blog-main-card">
//                       <img src={postsTechnicalBlogs[0].image} alt={postsTechnicalBlogs[0].header_title} className="hp-blog-main-img" loading="lazy" />
//                       <div className="hp-blog-main-body">
//                         <h3 className="hp-blog-main-title">{postsTechnicalBlogs[0].header_title}</h3>
//                         <span className="hp-blog-learn-more">Learn More →</span>
//                       </div>
//                     </div>
//                   </Link>
//                 )}
//               </div>
//               <div className="hp-blog-list">
//                 {loading ? Array.from({ length: 4 }).map((_, i) => (
//                   <div className="hp-blog-list-item" key={i}>
//                     <Skeleton width={80} height={62} style={{ borderRadius: 8, flexShrink: 0 }} />
//                     <div style={{ flex: 1 }}><Skeleton height={15} /><Skeleton width="50%" height={12} /></div>
//                   </div>
//                 )) : postsTechnicalBlogs.map(b => <BlogListItem key={b._id} blog={b} linkTo={blogLink(b)} />)}
//               </div>
//             </div>
//           </div>
//         </section>

//         {/* ══════════════════════════════════════════
//             INTERVIEW QUESTIONS
//         ══════════════════════════════════════════ */}
//         <section className="hp-section">
//           <div className="hp-section-inner">
//             <SectionHeader badge="🤝 INTERVIEW PREP" title="Our Popular Interview Questions"
//               linkTo="/blogs/all-blogs/interview_questions" linkLabel="View More" count={interviewCount} />
//             <div className="hp-cards-grid">
//               {loading ? Array.from({ length: 8 }).map((_, i) => <CardSkeleton key={i} />)
//                 : postsInterviewBlogs.map(b => (
//                     <ContentCard key={b._id} blog={b}
//                       linkTo={`/blogs/blog-post/${slugify(b.category_name)}/${slugify(b.sub_category_name.replace(/\0/g, "").trim())}/${b.slug}`} />
//                   ))}
//             </div>
//           </div>
//         </section>

//         {/* ══════════════════════════════════════════
//             CTA BANNER
//         ══════════════════════════════════════════ */}
//         <section className="hp-cta-banner">
//           <div className="hp-section-inner hp-cta-inner">
//             <div className="hp-cta-text">
//               <h2>Ready to start learning?</h2>
//               <p>Join over 1 Lakh students already practising on Acadebility.</p>
//             </div>
//             <div className="hp-cta-actions">
//               <Link to="/register"           className="hp-cta-btn-primary">Get Started Free</Link>
//               <Link to="/online-test-series" className="hp-cta-btn-ghost">Browse Tests</Link>
//             </div>
//           </div>
//         </section>

//       </div>
//     </>
//   );
// };

// export default HomePage;
// import React, { useEffect, useState } from "react";
// import { Helmet } from "react-helmet-async";
// import Skeleton from "react-loading-skeleton";
// import "react-loading-skeleton/dist/skeleton.css";
// import { Link } from "react-router-dom";
// import { slugify } from "../../utils/slugify";
// import { getRequest } from "../../services/api";
// import "./HomePage.css";

// interface BlogPost {
//   _id: string;
//   slug: string;
//   header_title: string;
//   url_title: string;
//   category_name: string;
//   sub_category_name: string;
//   test_category_name: string;
//   image: string;
//   posted_by: string;
//   updated_at: string;
//   views: number;
//   likes: number;
//   test_series_type?: string;
// }

// /* ─── SVG icons ──────────────────────────────────────────────────────────────── */
// const IconBook = () => (
//   <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
//     <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20"/><path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z"/>
//   </svg>
// );
// const IconGrad = () => (
//   <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
//     <path d="M22 10v6M2 10l10-5 10 5-10 5z"/><path d="M6 12v5c3 3 9 3 12 0v-5"/>
//   </svg>
// );
// const IconTag = () => (
//   <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
//     <path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z"/><line x1="7" y1="7" x2="7.01" y2="7"/>
//   </svg>
// );
// const IconChevron = () => (
//   <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><polyline points="9 18 15 12 9 6"/></svg>
// );
// const IconUsers = () => (
//   <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg>
// );
// const IconClock = () => (
//   <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>
// );
// const IconEye = () => (
//   <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/></svg>
// );
// const IconHeart = () => (
//   <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg>
// );

// /* ─── Test Series row-card (matches OTS style) ───────────────────────────────── */
// interface TestRowCardProps {
//   test: BlogPost;
//   linkTo: string;
//   iconType?: "book" | "grad" | "tag";
//   levelLabel?: string;
//   levelColor?: "teal" | "orange" | "blue";
// }
// const TestRowCard: React.FC<TestRowCardProps> = ({
//   test, linkTo, iconType = "book",
//   levelLabel = "Advanced", levelColor = "orange",
// }) => (
//   <Link to={linkTo} className="hp-ts-row-card">
//     <div className="hp-ts-row-left">
//       <div className={`hp-ts-row-icon hp-ts-icon-${iconType}`}>
//         {iconType === "grad" ? <IconGrad /> : iconType === "tag" ? <IconTag /> : <IconBook />}
//       </div>
//       <div className="hp-ts-row-info">
//         <div className="hp-ts-row-name">{test.sub_category_name}</div>
//         <div className="hp-ts-row-meta">
//           <span><IconBook />45 Tests</span>
//           <span><IconClock />3 hrs</span>
//           <span><IconUsers />2.5L+</span>
//         </div>
//       </div>
//     </div>
//     <div className="hp-ts-row-right">
//       <span className={`hp-ts-level hp-ts-level-${levelColor}`}>{levelLabel}</span>
//       <span className="hp-ts-row-arrow"><IconChevron /></span>
//     </div>
//   </Link>
// );

// /* ─── Section header ─────────────────────────────────────────────────────────── */
// interface SectionHeaderProps {
//   badge: string; title: string; linkTo: string; linkLabel: string; count?: number;
// }
// const SectionHeader: React.FC<SectionHeaderProps> = ({ badge, title, linkTo, linkLabel, count }) => (
//   <div className="hp-section-header">
//     <div className="hp-section-header-left">
//       <span className="hp-badge">{badge}</span>
//       <h2 className="hp-section-title">{title}</h2>
//     </div>
//     <Link to={linkTo} className="hp-view-all-btn">
//       {linkLabel}{count ? ` (${count})` : ""} →
//     </Link>
//   </div>
// );

// /* ─── Content card (MCQ / Interview) ────────────────────────────────────────── */
// interface ContentCardProps { blog: BlogPost; linkTo: string; }
// const ContentCard: React.FC<ContentCardProps> = ({ blog, linkTo }) => (
//   <Link to={linkTo} className="hp-content-card-link">
//     <div className="hp-content-card">
//       <div className="hp-card-thumb-wrap">
//         <img src={blog.image} alt={blog.header_title} className="hp-card-thumb" loading="lazy" />
//         <span className="hp-card-badge">-20% OFF</span>
//       </div>
//       <div className="hp-card-body">
//         <h3 className="hp-card-title">{blog.header_title}</h3>
//         <div className="hp-card-meta">
//           <span><IconEye />{blog.views} Views</span>
//           <span><IconHeart />{blog.likes} Likes</span>
//         </div>
//       </div>
//     </div>
//   </Link>
// );

// const CardSkeleton = () => (
//   <div className="hp-content-card">
//     <Skeleton height={200} style={{ borderRadius: "12px 12px 0 0" }} />
//     <div className="hp-card-body">
//       <Skeleton height={18} style={{ marginBottom: 8 }} /><Skeleton width="60%" height={14} />
//     </div>
//   </div>
// );

// interface BlogListItemProps { blog: BlogPost; linkTo: string; }
// const BlogListItem: React.FC<BlogListItemProps> = ({ blog, linkTo }) => (
//   <Link to={linkTo} className="hp-blog-list-item">
//     <img src={blog.image} alt={blog.header_title} className="hp-blog-list-thumb" loading="lazy" />
//     <div className="hp-blog-list-text">
//       <h4 className="hp-blog-list-title">{blog.header_title}</h4>
//       <span className="hp-blog-list-link">Read Article →</span>
//     </div>
//   </Link>
// );

// const FEATURES = [
//   { icon: "✅", title: "Topic-wise MCQ Practice",  desc: "Thousands of questions across all subjects & classes" },
//   { icon: "📋", title: "Full-length Mock Tests",    desc: "Simulate real exam conditions with timed tests" },
//   { icon: "📊", title: "Instant Score & Analysis", desc: "Know exactly where you stand after every attempt" },
//   { icon: "📰", title: "Expert Blog Posts",         desc: "Curated articles, technical guides & interview prep" },
//   { icon: "🆓", title: "Free Tests to Start",       desc: "Try before you buy — no account needed" },
// ];

// /* ─── Tab IDs ──────────────────────────────────────────────────────────────── */
// type TsTab = "exam" | "class" | "topic";

// /* ══════════════════════════════════════════════════════════════════════════════
//    MAIN COMPONENT
// ══════════════════════════════════════════════════════════════════════════════ */
// const HomePage: React.FC = () => {
//   const [examWise,    setExamWise]    = useState<BlogPost[]>([]);
//   const [classWise,   setClassWise]   = useState<BlogPost[]>([]);
//   const [topicWise,   setTopicWise]   = useState<BlogPost[]>([]);
//   const [mcqsBlogs,   setMcqsBlogs]   = useState<BlogPost[]>([]);
//   const [postsBlogs,  setPostsBlogs]  = useState<BlogPost[]>([]);
//   const [techBlogs,   setTechBlogs]   = useState<BlogPost[]>([]);
//   const [ivBlogs,     setIvBlogs]     = useState<BlogPost[]>([]);

//   const [examCount,   setExamCount]   = useState(0);
//   const [classCount,  setClassCount]  = useState(0);
//   const [topicCount,  setTopicCount]  = useState(0);
//   const [mcqsCount,   setMcqsCount]   = useState(0);
//   const [postsCount,  setPostsCount]  = useState(0);
//   const [techCount,   setTechCount]   = useState(0);
//   const [ivCount,     setIvCount]     = useState(0);

//   const [tsLoading,   setTsLoading]   = useState(true);
//   const [loading,     setLoading]     = useState(true);
//   const [activeTab,   setActiveTab]   = useState<TsTab>("exam");

//   useEffect(() => {
//     const fetchAll = async () => {
//       try {
//         // Test series (segmented)
//         const [ewRes, cwRes, twRes] = await Promise.all([
//           getRequest("/test-series", { category: "Test Series", test_series_type: "exam_wise",  limit: 6 }),
//           getRequest("/test-series", { category: "Test Series", test_series_type: "class_wise", limit: 6 }),
//           getRequest("/test-series", { category: "Test Series", test_series_type: "topic_wise", limit: 6 }),
//         ]);
//         setExamWise(ewRes.data.testSeries);   setExamCount(ewRes.data.totalCount);
//         setClassWise(cwRes.data.testSeries);  setClassCount(cwRes.data.totalCount);
//         setTopicWise(twRes.data.testSeries);  setTopicCount(twRes.data.totalCount);
//       } catch (err) {
//         console.error("Test series fetch error:", err);
//       } finally {
//         setTsLoading(false);
//       }

//       try {
//         const [mcqRes, postRes, techRes, ivRes] = await Promise.all([
//           getRequest("/blogs", { category: "mcqs",               limit: 8 }),
//           getRequest("/blogs", { category: "posts",              limit: 5 }),
//           getRequest("/blogs", { category: "technical_posts",    limit: 5 }),
//           getRequest("/blogs", { category: "interview_questions",limit: 8 }),
//         ]);
//         setMcqsBlogs(mcqRes.data.blogs);    setMcqsCount(mcqRes.data.totalCount);
//         setPostsBlogs(postRes.data.blogs);  setPostsCount(postRes.data.totalCount);
//         setTechBlogs(techRes.data.blogs);   setTechCount(techRes.data.totalCount);
//         setIvBlogs(ivRes.data.blogs);       setIvCount(ivRes.data.totalCount);
//       } catch (err) {
//         console.error("Blogs fetch error:", err);
//       } finally {
//         setLoading(false);
//       }
//     };
//     fetchAll();
//   }, []);

//   const blogLink = (b: BlogPost) =>
//     `/blogs/blog-post/${b.category_name ? slugify(b.category_name) : "category"}/${b.sub_category_name ? slugify(b.sub_category_name) : "subcategory"}/${b.slug}`;

//   const tsTabData: Record<TsTab, { tests: BlogPost[]; prefix: string; icon: "book"|"grad"|"tag"; level: string; color: "teal"|"orange"|"blue" }> = {
//     exam:  { tests: examWise,  prefix: "/online-test-series/exam-wise",  icon: "book", level: "Advanced", color: "orange" },
//     class: { tests: classWise, prefix: "/online-test-series/class-wise", icon: "grad", level: "Expert",   color: "blue"   },
//     topic: { tests: topicWise, prefix: "/online-test-series/topic-wise", icon: "tag",  level: "Beginner", color: "teal"   },
//   };
//   const active = tsTabData[activeTab];

//   return (
//     <>
//       <Helmet>
//         <title>Acadebility — Easy Learning</title>
//         <meta name="description" content="Practice MCQs, Test Series, Blog Posts and Interview Questions on Acadebility" />
//       </Helmet>

//       <div className="hp-page">

//         {/* ══ HERO ══════════════════════════════════════════════════ */}
//         <section className="hp-hero">
//           <div className="hp-hero-inner">

//             <div className="hp-hero-text">
//               <span className="hp-hero-badge">🏆 The Leader in Online Learning</span>
//               <h1 className="hp-hero-heading">
//                 Build Skills That<br />
//                 <span className="hp-hero-accent">Shape Your Future</span>
//               </h1>
//               <p className="hp-hero-sub">
//                 Practice with thousands of questions across JEE, NEET, UPSC,
//                 Banking, SSC, and more. Track your progress and achieve your goals.
//               </p>
//               <div className="hp-hero-actions">
//                 <Link to="/online-test-series" className="hp-hero-btn-primary">Explore Test Series →</Link>
//                 <Link to="/blogs/all-blogs/mcqs" className="hp-hero-btn-ghost">Browse MCQs</Link>
//               </div>
//               <div className="hp-hero-stats-row">
//                 {[
//                   { val: "500+", lbl: "Test Series" },
//                   { val: "10K+", lbl: "MCQ Questions" },
//                   { val: "1L+",  lbl: "Students" },
//                   { val: "4.8★", lbl: "Avg Rating" },
//                 ].map(s => (
//                   <div className="hp-hero-stat" key={s.lbl}>
//                     <span className="hp-hero-stat-val">{s.val}</span>
//                     <span className="hp-hero-stat-lbl">{s.lbl}</span>
//                   </div>
//                 ))}
//               </div>
//             </div>

//             <div className="hp-hero-panel">
//               <div className="hp-panel-chips">
//                 <div className="hp-panel-chip hp-panel-chip-teal">
//                   <span className="hp-panel-chip-icon">🎯</span>
//                   <div><div className="hp-panel-chip-val">500+</div><div className="hp-panel-chip-lbl">Test Series</div></div>
//                 </div>
//                 <div className="hp-panel-chip hp-panel-chip-purple">
//                   <span className="hp-panel-chip-icon">👥</span>
//                   <div><div className="hp-panel-chip-val">1L+</div><div className="hp-panel-chip-lbl">Students</div></div>
//                 </div>
//               </div>
//               <div className="hp-panel-card">
//                 <p className="hp-panel-card-heading">What you get on Acadebility</p>
//                 <div className="hp-panel-features">
//                   {FEATURES.map(f => (
//                     <div className="hp-panel-feature" key={f.title}>
//                       <span className="hp-panel-feature-icon">{f.icon}</span>
//                       <div>
//                         <div className="hp-panel-feature-title">{f.title}</div>
//                         <div className="hp-panel-feature-desc">{f.desc}</div>
//                       </div>
//                     </div>
//                   ))}
//                 </div>
//               </div>
//               <div className="hp-panel-cta">
//                 <span className="hp-panel-cta-emoji">🚀</span>
//                 <div className="hp-panel-cta-text">
//                   <strong>Start for free today</strong>
//                   <span>No credit card required</span>
//                 </div>
//                 <Link to="/register" className="hp-panel-cta-btn">Join Now →</Link>
//               </div>
//             </div>
//           </div>
//         </section>

//         {/* ══ CATEGORY CHIPS ════════════════════════════════════════ */}
//         <section className="hp-categories">
//           <div className="hp-section-inner">
//             {[
//               { emoji: "🎯", label: "Test Series",         to: "/online-test-series" },
//               { emoji: "❓", label: "MCQ Practice",        to: "/blogs/all-blogs/mcqs" },
//               { emoji: "📰", label: "Blog Posts",          to: "/blogs/all-blogs/posts" },
//               { emoji: "💻", label: "Technical Blogs",     to: "/blogs/all-blogs/technical_posts" },
//               { emoji: "🤝", label: "Interview Questions", to: "/blogs/all-blogs/interview_questions" },
//             ].map(c => (
//               <Link to={c.to} className="hp-cat-chip" key={c.label}>
//                 <span className="hp-cat-emoji">{c.emoji}</span>{c.label}
//               </Link>
//             ))}
//           </div>
//         </section>

//         {/* ══ TEST SERIES — SEGMENTED ═══════════════════════════════ */}
//         <section className="hp-section hp-section-alt">
//           <div className="hp-section-inner">

//             {/* Section top bar */}
//             <div className="hp-ts-topbar">
//               <div>
//                 <span className="hp-badge">🎯 TEST SERIES</span>
//                 <h2 className="hp-section-title" style={{ marginTop: 6 }}>Explore Our Test Series</h2>
//                 <p className="hp-ts-subtitle">Choose your preparation track — competitive exams, school classes, or subject topics</p>
//               </div>
//               <Link to="/online-test-series" className="hp-view-all-btn">View All Tests →</Link>
//             </div>

//             {/* Tab switcher */}
//             <div className="hp-ts-tabs">
//               {([
//                 { id: "exam"  as TsTab, icon: "📚", label: "Exam Wise",  count: examCount  },
//                 { id: "class" as TsTab, icon: "🎓", label: "Class Wise", count: classCount },
//                 { id: "topic" as TsTab, icon: "🏷️", label: "Topic Wise", count: topicCount },
//               ]).map(t => (
//                 <button
//                   key={t.id}
//                   className={`hp-ts-tab ${activeTab === t.id ? "hp-ts-tab-active" : ""}`}
//                   onClick={() => setActiveTab(t.id)}
//                   type="button"
//                 >
//                   <span className="hp-ts-tab-emoji">{t.icon}</span>
//                   <span className="hp-ts-tab-label">{t.label}</span>
//                   {t.count > 0 && <span className="hp-ts-tab-count">{t.count}</span>}
//                 </button>
//               ))}
//             </div>

//             {/* Cards grid */}
//             <div className="hp-ts-grid">
//               {tsLoading
//                 ? Array.from({ length: 6 }).map((_, i) => (
//                     <div className="hp-ts-row-card hp-ts-row-skeleton" key={i}>
//                       <Skeleton height={20} width="50%" style={{ marginBottom: 10 }} />
//                       <Skeleton height={14} width="80%" />
//                     </div>
//                   ))
//                 : active.tests.map(t => (
//                     <TestRowCard
//                       key={t._id}
//                       test={t}
//                       linkTo={`${active.prefix}/${slugify(t.sub_category_name)}`}
//                       iconType={active.icon}
//                       levelLabel={active.level}
//                       levelColor={active.color}
//                     />
//                   ))}
//             </div>

//             {/* View all CTA row */}
//             <div className="hp-ts-view-all-row">
//               <Link to="/online-test-series" className="hp-ts-view-all-link">
//                 Browse all {activeTab === "exam" ? "Exam Wise" : activeTab === "class" ? "Class Wise" : "Topic Wise"} tests →
//               </Link>
//             </div>

//           </div>
//         </section>

//         {/* ══ BLOG POSTS ════════════════════════════════════════════ */}
//         <section className="hp-section">
//           <div className="hp-section-inner">
//             <SectionHeader badge="📰 BLOG POST" title="Latest Blog Posts"
//               linkTo="/blogs/all-blogs/posts" linkLabel="See All Blogs" count={postsCount} />
//             <div className="hp-blog-layout">
//               <div className="hp-blog-main">
//                 {loading || !postsBlogs[0] ? (
//                   <><Skeleton height={320} style={{ borderRadius: 14 }} /><Skeleton height={22} style={{ marginTop: 14 }} /></>
//                 ) : (
//                   <Link to={blogLink(postsBlogs[0])} state={{ id: postsBlogs[0]._id }} className="hp-blog-main-link">
//                     <div className="hp-blog-main-card">
//                       <img src={postsBlogs[0].image} alt={postsBlogs[0].header_title} className="hp-blog-main-img" loading="lazy" />
//                       <div className="hp-blog-main-body">
//                         <h3 className="hp-blog-main-title">{postsBlogs[0].header_title}</h3>
//                         <span className="hp-blog-learn-more">Learn More →</span>
//                       </div>
//                     </div>
//                   </Link>
//                 )}
//               </div>
//               <div className="hp-blog-list">
//                 {loading ? Array.from({ length: 4 }).map((_, i) => (
//                   <div className="hp-blog-list-item" key={i}>
//                     <Skeleton width={80} height={62} style={{ borderRadius: 8, flexShrink: 0 }} />
//                     <div style={{ flex: 1 }}><Skeleton height={15} /><Skeleton width="50%" height={12} /></div>
//                   </div>
//                 )) : postsBlogs.map(b => <BlogListItem key={b._id} blog={b} linkTo={blogLink(b)} />)}
//               </div>
//             </div>
//           </div>
//         </section>

//         {/* ══ MCQ ═══════════════════════════════════════════════════ */}
//         <section className="hp-section hp-section-alt">
//           <div className="hp-section-inner">
//             <SectionHeader badge="❓ TOP MCQs" title="Our Popular MCQs"
//               linkTo="/blogs/all-blogs/mcqs" linkLabel="View More" count={mcqsCount} />
//             <div className="hp-cards-grid">
//               {loading ? Array.from({ length: 8 }).map((_, i) => <CardSkeleton key={i} />)
//                 : mcqsBlogs.map(b => (
//                     <ContentCard key={b._id} blog={b}
//                       linkTo={`/mcqs/mcqs-post/${slugify(b.category_name)}/${slugify(b.sub_category_name.replace(/\0/g, "").trim())}/${b.slug}`} />
//                   ))}
//             </div>
//           </div>
//         </section>

//         {/* ══ TECHNICAL BLOGS ═══════════════════════════════════════ */}
//         <section className="hp-section">
//           <div className="hp-section-inner">
//             <SectionHeader badge="💻 TECHNICAL" title="Latest Technical Blog Posts"
//               linkTo="/blogs/all-blogs/technical_posts" linkLabel="See All Technical Blogs" count={techCount} />
//             <div className="hp-blog-layout">
//               <div className="hp-blog-main">
//                 {loading || !techBlogs[0] ? (
//                   <><Skeleton height={320} style={{ borderRadius: 14 }} /><Skeleton height={22} style={{ marginTop: 14 }} /></>
//                 ) : (
//                   <Link to={blogLink(techBlogs[0])} state={{ id: techBlogs[0]._id }} className="hp-blog-main-link">
//                     <div className="hp-blog-main-card">
//                       <img src={techBlogs[0].image} alt={techBlogs[0].header_title} className="hp-blog-main-img" loading="lazy" />
//                       <div className="hp-blog-main-body">
//                         <h3 className="hp-blog-main-title">{techBlogs[0].header_title}</h3>
//                         <span className="hp-blog-learn-more">Learn More →</span>
//                       </div>
//                     </div>
//                   </Link>
//                 )}
//               </div>
//               <div className="hp-blog-list">
//                 {loading ? Array.from({ length: 4 }).map((_, i) => (
//                   <div className="hp-blog-list-item" key={i}>
//                     <Skeleton width={80} height={62} style={{ borderRadius: 8, flexShrink: 0 }} />
//                     <div style={{ flex: 1 }}><Skeleton height={15} /><Skeleton width="50%" height={12} /></div>
//                   </div>
//                 )) : techBlogs.map(b => <BlogListItem key={b._id} blog={b} linkTo={blogLink(b)} />)}
//               </div>
//             </div>
//           </div>
//         </section>

//         {/* ══ INTERVIEW QUESTIONS ═══════════════════════════════════ */}
//         <section className="hp-section hp-section-alt">
//           <div className="hp-section-inner">
//             <SectionHeader badge="🤝 INTERVIEW PREP" title="Our Popular Interview Questions"
//               linkTo="/blogs/all-blogs/interview_questions" linkLabel="View More" count={ivCount} />
//             <div className="hp-cards-grid">
//               {loading ? Array.from({ length: 8 }).map((_, i) => <CardSkeleton key={i} />)
//                 : ivBlogs.map(b => (
//                     <ContentCard key={b._id} blog={b}
//                       linkTo={`/blogs/blog-post/${slugify(b.category_name)}/${slugify(b.sub_category_name.replace(/\0/g, "").trim())}/${b.slug}`} />
//                   ))}
//             </div>
//           </div>
//         </section>

//         {/* ══ CTA BANNER ════════════════════════════════════════════ */}
//         <section className="hp-cta-banner">
//           <div className="hp-section-inner hp-cta-inner">
//             <div className="hp-cta-text">
//               <h2>Ready to start learning?</h2>
//               <p>Join over 1 Lakh students already practising on Acadebility.</p>
//             </div>
//             <div className="hp-cta-actions">
//               <Link to="/register"           className="hp-cta-btn-primary">Get Started Free</Link>
//               <Link to="/online-test-series" className="hp-cta-btn-ghost">Browse Tests</Link>
//             </div>
//           </div>
//         </section>

//       </div>
//     </>
//   );
// };

// export default HomePage;

import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { Link } from "react-router-dom";
import { slugify } from "../../utils/slugify";
import { getRequest } from "../../services/api";
import "./HomePage.css";

interface BlogPost {
  _id: string;
  slug: string;
  header_title: string;
  url_title: string;
  category_name: string;
  sub_category_name: string;
  test_category_name: string;
  image: string;
  posted_by: string;
  updated_at: string;
  views: number;
  likes: number;
  test_series_type?: string;
}

/* ─── SVG icons (identical to original) ─────────────────────────────────── */
const IconBook = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20"/><path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z"/>
  </svg>
);
const IconGrad = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M22 10v6M2 10l10-5 10 5-10 5z"/><path d="M6 12v5c3 3 9 3 12 0v-5"/>
  </svg>
);
const IconTag = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z"/><line x1="7" y1="7" x2="7.01" y2="7"/>
  </svg>
);
const IconChevron = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><polyline points="9 18 15 12 9 6"/></svg>
);
const IconUsers = () => (
  <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg>
);
const IconClock = () => (
  <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>
);
const IconEye = () => (
  <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/></svg>
);
const IconHeart = () => (
  <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg>
);
const IconPen = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M12 20h9"/><path d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4L16.5 3.5z"/>
  </svg>
);
const IconBrain = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M9.5 2a2.5 2.5 0 0 1 5 0v.5a2.5 2.5 0 0 1-5 0V2z"/><path d="M4 9a5 5 0 0 1 10 0v10H4V9z"/><path d="M20 9a5 5 0 0 0-10 0"/>
  </svg>
);
const IconCode = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="16 18 22 12 16 6"/><polyline points="8 6 2 12 8 18"/>
  </svg>
);
const IconMic = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M12 1a3 3 0 0 0-3 3v8a3 3 0 0 0 6 0V4a3 3 0 0 0-3-3z"/><path d="M19 10v2a7 7 0 0 1-14 0v-2"/><line x1="12" y1="19" x2="12" y2="23"/><line x1="8" y1="23" x2="16" y2="23"/>
  </svg>
);

/* ─── IDENTICAL: Test Series row-card ───────────────────────────────────── */
interface TestRowCardProps {
  test: BlogPost;
  linkTo: string;
  iconType?: "book" | "grad" | "tag";
  levelLabel?: string;
  levelColor?: "teal" | "orange" | "blue";
}
const TestRowCard: React.FC<TestRowCardProps> = ({
  test, linkTo, iconType = "book",
  levelLabel = "Advanced", levelColor = "orange",
}) => (
  <Link to={linkTo} className="hp-ts-row-card">
    <div className="hp-ts-row-left">
      <div className={`hp-ts-row-icon hp-ts-icon-${iconType}`}>
        {iconType === "grad" ? <IconGrad /> : iconType === "tag" ? <IconTag /> : <IconBook />}
      </div>
      <div className="hp-ts-row-info">
        <div className="hp-ts-row-name">{test.sub_category_name}</div>
        <div className="hp-ts-row-meta">
          <span><IconBook />45 Tests</span>
          <span><IconClock />3 hrs</span>
          <span><IconUsers />2.5L+</span>
        </div>
      </div>
    </div>
    <div className="hp-ts-row-right">
      <span className={`hp-ts-level hp-ts-level-${levelColor}`}>{levelLabel}</span>
      <span className="hp-ts-row-arrow"><IconChevron /></span>
    </div>
  </Link>
);

/* ─── NEW: Content row-card — same structure, different icon/accent ──────── */
type AccentColor = "orange" | "purple" | "blue" | "green";

interface ContentRowCardProps {
  blog: BlogPost;
  linkTo: string;
  accent: AccentColor;
  icon: React.ReactNode;
  metaLabel?: string;
}
const ContentRowCard: React.FC<ContentRowCardProps> = ({ blog, linkTo, accent, icon, metaLabel }) => (
  <Link to={linkTo} className={`hp-ts-row-card hp-row-card-${accent}`}>
    <div className="hp-ts-row-left">
      <div className={`hp-ts-row-icon hp-row-icon-${accent}`}>
        {icon}
      </div>
      <div className="hp-ts-row-info">
        <div className="hp-ts-row-name">{blog.header_title}</div>
        <div className="hp-ts-row-meta">
          <span><IconEye />{blog.views} Views</span>
          <span><IconHeart />{blog.likes} Likes</span>
          {metaLabel && <span>{metaLabel}</span>}
        </div>
      </div>
    </div>
    <div className="hp-ts-row-right">
      <span className="hp-ts-row-arrow"><IconChevron /></span>
    </div>
  </Link>
);

/* ─── IDENTICAL: Section header ─────────────────────────────────────────── */
interface SectionHeaderProps {
  badge: string; title: string; subtitle?: string;
  linkTo: string; linkLabel: string; count?: number;
}
const SectionHeader: React.FC<SectionHeaderProps> = ({ badge, title, subtitle, linkTo, linkLabel, count }) => (
  <div className="hp-ts-topbar">
    <div>
      <span className="hp-badge">{badge}</span>
      <h2 className="hp-section-title" style={{ marginTop: 6 }}>{title}</h2>
      {subtitle && <p className="hp-ts-subtitle">{subtitle}</p>}
    </div>
    <Link to={linkTo} className="hp-view-all-btn">
      {linkLabel}{count ? ` (${count})` : ""} →
    </Link>
  </div>
);

/* ─── Skeleton row ───────────────────────────────────────────────────────── */
const RowSkeleton = () => (
  <div className="hp-ts-row-card hp-ts-row-skeleton">
    <Skeleton height={20} width="50%" style={{ marginBottom: 10 }} />
    <Skeleton height={14} width="80%" />
  </div>
);

const FEATURES = [
  { icon: "✅", title: "Topic-wise MCQ Practice",  desc: "Thousands of questions across all subjects & classes" },
  { icon: "📋", title: "Full-length Mock Tests",    desc: "Simulate real exam conditions with timed tests" },
  { icon: "📊", title: "Instant Score & Analysis", desc: "Know exactly where you stand after every attempt" },
  { icon: "📰", title: "Expert Blog Posts",         desc: "Curated articles, technical guides & interview prep" },
  { icon: "🆓", title: "Free Tests to Start",       desc: "Try before you buy — no account needed" },
];

type TsTab = "exam" | "class" | "topic";

const HomePage: React.FC = () => {
  const [examWise,   setExamWise]   = useState<BlogPost[]>([]);
  const [classWise,  setClassWise]  = useState<BlogPost[]>([]);
  const [topicWise,  setTopicWise]  = useState<BlogPost[]>([]);
  const [mcqsBlogs,  setMcqsBlogs]  = useState<BlogPost[]>([]);
  const [postsBlogs, setPostsBlogs] = useState<BlogPost[]>([]);
  const [techBlogs,  setTechBlogs]  = useState<BlogPost[]>([]);
  const [ivBlogs,    setIvBlogs]    = useState<BlogPost[]>([]);

  const [examCount,  setExamCount]  = useState(0);
  const [classCount, setClassCount] = useState(0);
  const [topicCount, setTopicCount] = useState(0);
  const [mcqsCount,  setMcqsCount]  = useState(0);
  const [postsCount, setPostsCount] = useState(0);
  const [techCount,  setTechCount]  = useState(0);
  const [ivCount,    setIvCount]    = useState(0);

  const [tsLoading, setTsLoading] = useState(true);
  const [loading,   setLoading]   = useState(true);
  const [activeTab, setActiveTab] = useState<TsTab>("exam");

  useEffect(() => {
    const fetchAll = async () => {
      try {
        const [ewRes, cwRes, twRes] = await Promise.all([
          getRequest("/test-series", { category: "Test Series", test_series_type: "exam_wise",  limit: 6 }),
          getRequest("/test-series", { category: "Test Series", test_series_type: "class_wise", limit: 6 }),
          getRequest("/test-series", { category: "Test Series", test_series_type: "topic_wise", limit: 6 }),
        ]);
        setExamWise(ewRes.data.testSeries);   setExamCount(ewRes.data.totalCount);
        setClassWise(cwRes.data.testSeries);  setClassCount(cwRes.data.totalCount);
        setTopicWise(twRes.data.testSeries);  setTopicCount(twRes.data.totalCount);
      } catch (err) {
        console.error("Test series fetch error:", err);
      } finally {
        setTsLoading(false);
      }

      try {
        const [mcqRes, postRes, techRes, ivRes] = await Promise.all([
          getRequest("/blogs", { category: "mcqs",                limit: 8 }),
          getRequest("/blogs", { category: "posts",               limit: 8 }),
          getRequest("/blogs", { category: "technical_posts",     limit: 8 }),
          getRequest("/blogs", { category: "interview_questions", limit: 8 }),
        ]);
        setMcqsBlogs(mcqRes.data.blogs);    setMcqsCount(mcqRes.data.totalCount);
        setPostsBlogs(postRes.data.blogs);  setPostsCount(postRes.data.totalCount);
        setTechBlogs(techRes.data.blogs);   setTechCount(techRes.data.totalCount);
        setIvBlogs(ivRes.data.blogs);       setIvCount(ivRes.data.totalCount);
      } catch (err) {
        console.error("Blogs fetch error:", err);
      } finally {
        setLoading(false);
      }
    };
    fetchAll();
  }, []);

  const blogLink = (b: BlogPost) =>
    `/blogs/blog-post/${b.category_name ? slugify(b.category_name) : "category"}/${b.sub_category_name ? slugify(b.sub_category_name) : "subcategory"}/${b.slug}`;

  const tsTabData: Record<TsTab, { tests: BlogPost[]; prefix: string; icon: "book"|"grad"|"tag"; level: string; color: "teal"|"orange"|"blue" }> = {
    exam:  { tests: examWise,  prefix: "/online-test-series/exam-wise",  icon: "book", level: "Advanced", color: "orange" },
    class: { tests: classWise, prefix: "/online-test-series/class-wise", icon: "grad", level: "Expert",   color: "blue"   },
    topic: { tests: topicWise, prefix: "/online-test-series/topic-wise", icon: "tag",  level: "Beginner", color: "teal"   },
  };
  const active = tsTabData[activeTab];

  return (
    <>
      <Helmet>
        <title>Acadebility — Easy Learning</title>
        <meta name="description" content="Practice MCQs, Test Series, Blog Posts and Interview Questions on Acadebility" />
      </Helmet>

      <div className="hp-page">

        {/* ══ HERO — IDENTICAL ═══════════════════════════════════════ */}
        <section className="hp-hero">
          <div className="hp-hero-inner">
            <div className="hp-hero-text">
              <span className="hp-hero-badge">🏆 The Leader in Online Learning</span>
              <h1 className="hp-hero-heading">
                Build Skills That<br />
                <span className="hp-hero-accent">Shape Your Future</span>
              </h1>
              <p className="hp-hero-sub">
                Practice with thousands of questions across JEE, NEET, UPSC,
                Banking, SSC, and more. Track your progress and achieve your goals.
              </p>
              <div className="hp-hero-actions">
                <Link to="/online-test-series" className="hp-hero-btn-primary">Explore Test Series →</Link>
                <Link to="/blogs/all-blogs/mcqs" className="hp-hero-btn-ghost">Browse MCQs</Link>
              </div>
              <div className="hp-hero-stats-row">
                {[
                  { val: "500+", lbl: "Test Series" },
                  { val: "10K+", lbl: "MCQ Questions" },
                  { val: "1L+",  lbl: "Students" },
                  { val: "4.8★", lbl: "Avg Rating" },
                ].map(s => (
                  <div className="hp-hero-stat" key={s.lbl}>
                    <span className="hp-hero-stat-val">{s.val}</span>
                    <span className="hp-hero-stat-lbl">{s.lbl}</span>
                  </div>
                ))}
              </div>
            </div>

            <div className="hp-hero-panel">
              <div className="hp-panel-chips">
                <div className="hp-panel-chip hp-panel-chip-teal">
                  <span className="hp-panel-chip-icon">🎯</span>
                  <div><div className="hp-panel-chip-val">500+</div><div className="hp-panel-chip-lbl">Test Series</div></div>
                </div>
                <div className="hp-panel-chip hp-panel-chip-purple">
                  <span className="hp-panel-chip-icon">👥</span>
                  <div><div className="hp-panel-chip-val">1L+</div><div className="hp-panel-chip-lbl">Students</div></div>
                </div>
              </div>
              <div className="hp-panel-card">
                <p className="hp-panel-card-heading">What you get on Acadebility</p>
                <div className="hp-panel-features">
                  {FEATURES.map(f => (
                    <div className="hp-panel-feature" key={f.title}>
                      <span className="hp-panel-feature-icon">{f.icon}</span>
                      <div>
                        <div className="hp-panel-feature-title">{f.title}</div>
                        <div className="hp-panel-feature-desc">{f.desc}</div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
              {/* <div className="hp-panel-cta">
                <span className="hp-panel-cta-emoji">🚀</span>
                <div className="hp-panel-cta-text">
                  <strong>Start for free today</strong>
                  <span>No credit card required</span>
                </div>
                <Link to="/register" className="hp-panel-cta-btn">Join Now →</Link>
              </div> */}
            </div>
          </div>
        </section>

        {/* ══ CATEGORY CHIPS — IDENTICAL ════════════════════════════ */}
        <section className="hp-categories">
          <div className="hp-section-inner">
            {[
              { emoji: "🎯", label: "Test Series",         to: "/online-test-series" },
              { emoji: "❓", label: "MCQ Practice",        to: "/blogs/all-blogs/mcqs" },
              { emoji: "📰", label: "Blog Posts",          to: "/blogs/all-blogs/posts" },
              { emoji: "💻", label: "Technical Blogs",     to: "/blogs/all-blogs/technical_posts" },
              { emoji: "🤝", label: "Interview Questions", to: "/blogs/all-blogs/interview_questions" },
            ].map(c => (
              <Link to={c.to} className="hp-cat-chip" key={c.label}>
                <span className="hp-cat-emoji">{c.emoji}</span>{c.label}
              </Link>
            ))}
          </div>
        </section>

        {/* ══ TEST SERIES — IDENTICAL ═══════════════════════════════ */}
        <section className="hp-section hp-section-alt">
          <div className="hp-section-inner">
            <div className="hp-ts-topbar">
              <div>
                <span className="hp-badge">🎯 TEST SERIES</span>
                <h2 className="hp-section-title" style={{ marginTop: 6 }}>Explore Our Test Series</h2>
                <p className="hp-ts-subtitle">Choose your preparation track — competitive exams, school classes, or subject topics</p>
              </div>
              <Link to="/online-test-series" className="hp-view-all-btn">View All Tests →</Link>
            </div>

            <div className="hp-ts-tabs">
              {([
                { id: "exam"  as TsTab, icon: "📚", label: "Exam Wise",  count: examCount  },
                { id: "class" as TsTab, icon: "🎓", label: "Class Wise", count: classCount },
                { id: "topic" as TsTab, icon: "🏷️", label: "Topic Wise", count: topicCount },
              ]).map(t => (
                <button
                  key={t.id}
                  className={`hp-ts-tab ${activeTab === t.id ? "hp-ts-tab-active" : ""}`}
                  onClick={() => setActiveTab(t.id)}
                  type="button"
                >
                  <span className="hp-ts-tab-emoji">{t.icon}</span>
                  <span className="hp-ts-tab-label">{t.label}</span>
                  {t.count > 0 && <span className="hp-ts-tab-count">{t.count}</span>}
                </button>
              ))}
            </div>

            <div className="hp-ts-grid">
              {tsLoading
                ? Array.from({ length: 6 }).map((_, i) => <RowSkeleton key={i} />)
                : active.tests.map(t => (
                    <TestRowCard
                      key={t._id}
                      test={t}
                      linkTo={`${active.prefix}/${slugify(t.sub_category_name)}`}
                      iconType={active.icon}
                      levelLabel={active.level}
                      levelColor={active.color}
                    />
                  ))}
            </div>

            <div className="hp-ts-view-all-row">
              <Link to="/online-test-series" className="hp-ts-view-all-link">
                Browse all {activeTab === "exam" ? "Exam Wise" : activeTab === "class" ? "Class Wise" : "Topic Wise"} tests →
              </Link>
            </div>
          </div>
        </section>

        {/* ══ LATEST BLOG POSTS — row-card style ════════════════════ */}
        <section className="hp-section">
          <div className="hp-section-inner">
            <SectionHeader
              badge="📰 BLOG POST"
              title="Latest Blog Posts"
              subtitle="Insights, guides and stories from our editorial team"
              linkTo="/blogs/all-blogs/posts"
              linkLabel="See All Blogs"
              count={postsCount}
            />
            <div className="hp-ts-grid">
              {loading
                ? Array.from({ length: 6 }).map((_, i) => <RowSkeleton key={i} />)
                : postsBlogs.map(b => (
                    <ContentRowCard
                      key={b._id}
                      blog={b}
                      linkTo={blogLink(b)}
                      accent="orange"
                      icon={<IconPen />}
                      metaLabel={b.posted_by ? `✍ ${b.posted_by}` : undefined}
                    />
                  ))}
            </div>
            <div className="hp-ts-view-all-row">
              <Link to="/blogs/all-blogs/posts" className="hp-ts-view-all-link hp-vaal-orange">
                Browse all Blog Posts →
              </Link>
            </div>
          </div>
        </section>

        {/* ══ OUR POPULAR MCQs — row-card style ════════════════════ */}
        <section className="hp-section hp-section-alt">
          <div className="hp-section-inner">
            <SectionHeader
              badge="❓ TOP MCQs"
              title="Our Popular MCQs"
              subtitle="Practice with the most-attempted question sets"
              linkTo="/blogs/all-blogs/mcqs"
              linkLabel="View More"
              count={mcqsCount}
            />
            <div className="hp-ts-grid">
              {loading
                ? Array.from({ length: 6 }).map((_, i) => <RowSkeleton key={i} />)
                : mcqsBlogs.map(b => (
                    <ContentRowCard
                      key={b._id}
                      blog={b}
                      linkTo={`/mcqs/mcqs-post/${slugify(b.category_name)}/${slugify(b.sub_category_name.replace(/\0/g, "").trim())}/${b.slug}`}
                      accent="purple"
                      icon={<IconBrain />}
                      metaLabel={b.sub_category_name || b.category_name}
                    />
                  ))}
            </div>
            <div className="hp-ts-view-all-row">
              <Link to="/blogs/all-blogs/mcqs" className="hp-ts-view-all-link hp-vaal-purple">
                Browse all MCQs →
              </Link>
            </div>
          </div>
        </section>

        {/* ══ LATEST TECHNICAL BLOG POSTS — row-card style ══════════ */}
        <section className="hp-section">
          <div className="hp-section-inner">
            <SectionHeader
              badge="💻 TECHNICAL"
              title="Latest Technical Blog Posts"
              subtitle="Deep-dives into tech, tools, and engineering topics"
              linkTo="/blogs/all-blogs/technical_posts"
              linkLabel="See All Technical Blogs"
              count={techCount}
            />
            <div className="hp-ts-grid">
              {loading
                ? Array.from({ length: 6 }).map((_, i) => <RowSkeleton key={i} />)
                : techBlogs.map(b => (
                    <ContentRowCard
                      key={b._id}
                      blog={b}
                      linkTo={blogLink(b)}
                      accent="blue"
                      icon={<IconCode />}
                      metaLabel={b.posted_by ? `✍ ${b.posted_by}` : undefined}
                    />
                  ))}
            </div>
            <div className="hp-ts-view-all-row">
              <Link to="/blogs/all-blogs/technical_posts" className="hp-ts-view-all-link hp-vaal-blue">
                Browse all Technical Blogs →
              </Link>
            </div>
          </div>
        </section>

        {/* ══ OUR POPULAR INTERVIEW QUESTIONS — row-card style ══════ */}
        <section className="hp-section hp-section-alt">
          <div className="hp-section-inner">
            <SectionHeader
              badge="🤝 INTERVIEW PREP"
              title="Our Popular Interview Questions"
              subtitle="Ace your next interview with targeted question banks"
              linkTo="/blogs/all-blogs/interview_questions"
              linkLabel="View More"
              count={ivCount}
            />
            <div className="hp-ts-grid">
              {loading
                ? Array.from({ length: 6 }).map((_, i) => <RowSkeleton key={i} />)
                : ivBlogs.map(b => (
                    <ContentRowCard
                      key={b._id}
                      blog={b}
                      linkTo={`/blogs/blog-post/${slugify(b.category_name)}/${slugify(b.sub_category_name.replace(/\0/g, "").trim())}/${b.slug}`}
                      accent="green"
                      icon={<IconMic />}
                      metaLabel={b.sub_category_name || b.category_name}
                    />
                  ))}
            </div>
            <div className="hp-ts-view-all-row">
              <Link to="/blogs/all-blogs/interview_questions" className="hp-ts-view-all-link hp-vaal-green">
                Browse all Interview Questions →
              </Link>
            </div>
          </div>
        </section>

        {/* ══ CTA BANNER — IDENTICAL ════════════════════════════════ */}
        <section className="hp-cta-banner">
          <div className="hp-section-inner hp-cta-inner">
            <div className="hp-cta-text">
              <h2>Ready to start learning?</h2>
              <p>Join over 1 Lakh students already practising on Acadebility.</p>
            </div>
            <div className="hp-cta-actions">
              <Link to="/register"           className="hp-cta-btn-primary">Get Started Free</Link>
              <Link to="/online-test-series" className="hp-cta-btn-ghost">Browse Tests</Link>
            </div>
          </div>
        </section>

      </div>
    </>
  );
};

export default HomePage;


